import { createContext } from 'react';
var userCompAttributeDetails = {
  data: [{
    id: '',
    valId: '',
    attributeName: '',
    dataType: '',
    required: false,
    value: ''
  }]
};
var defaultState = {
  userCompAttributesData: userCompAttributeDetails.data
};
var UserCompanyAttributeDetailsContext = /*#__PURE__*/createContext(defaultState);
export { UserCompanyAttributeDetailsContext, userCompAttributeDetails };